import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import { callLicenseRequestStatus } from "../request/request.section";
import { callRequestType } from "../request/license/request-license.section";
import store from "../../../../store";

export const callDepartment = ({ searchQuery }) => store.dispatch("resource/v1/master/department/cacheFindAll", { searchQuery });

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.licenseRequest.requestCode"), dataIndex: "requestCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("model.licenseRequest.requester"),
            dataIndex: "refRequester.fullNameTh",
            align: "center"
        }),
        createColumnDate({ title: () => i18n.global.t("model.licenseRequest.requestDate"), dataIndex: "requestDate", align: "center"}),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refReceiveDept"),
            dataIndex: "refReceiveDept.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refReceiveDept.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refRequestType"),
            dataIndex: "refRequestType.value",
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callLicenseRequestStatus, optLabel: "value" }),
            search: { name: "refStatus.id" }
        }),
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
